import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string;
  change: string;
  status: 'positive' | 'negative' | 'neutral';
  onClick: () => void;
}
export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  status,
  onClick
}) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'positive':
        return <TrendingUpIcon size={16} className="text-green-500" data-id="element-1028" />;
      case 'negative':
        return <TrendingDownIcon size={16} className="text-red-500" data-id="element-1029" />;
      case 'neutral':
        return <MinusIcon size={16} className="text-gray-500" data-id="element-1030" />;
    }
  };
  const getStatusClass = () => {
    switch (status) {
      case 'positive':
        return 'text-green-500';
      case 'negative':
        return 'text-red-500';
      case 'neutral':
        return 'text-gray-500';
    }
  };
  return <button onClick={onClick} className="bg-white rounded-xl shadow-sm p-4 transition-transform hover:scale-105" data-id="element-1031">
      <p className="text-gray-500 text-sm mb-1" data-id="element-1032">{title}</p>
      <p className="text-gray-800 text-xl font-semibold" data-id="element-1033">{value}</p>
      <div className="flex items-center mt-2" data-id="element-1034">
        {getStatusIcon()}
        <span className={`text-xs ml-1 ${getStatusClass()}`} data-id="element-1035">{change}</span>
      </div>
    </button>;
};